export default __webpack_public_path__ + "static/media/toggle-left.b4391399.svg";